import { render, staticRenderFns } from "./section4.vue?vue&type=template&id=1d5eff77&scoped=true"
import script from "./section4.vue?vue&type=script&lang=js"
export * from "./section4.vue?vue&type=script&lang=js"
import style0 from "./section4.vue?vue&type=style&index=0&id=1d5eff77&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5eff77",
  null
  
)

export default component.exports